import { Extension } from '@tiptap/core';

const TAB_SPACES = '\u00a0\u00a0\u00a0\u00a0';

export const TabIndent = Extension.create({
	name: 'tabIndent',

	addKeyboardShortcuts() {
		return {
			Tab: () => {
				if (this.editor.isActive('listItem')) {
					return this.editor.commands.sinkListItem('listItem');
				}
				return this.editor.chain().focus().insertContent(TAB_SPACES).run();
			},
			'Shift-Tab': () => {
				if (this.editor.isActive('listItem')) {
					return this.editor.commands.liftListItem('listItem');
				}
				return true;
			},
		};
	},
});

export default TabIndent;
